export default "__VITE_ASSET__54343894__"